/**
 * Fechas en la hora de QUIEN CAPTURA, no en UTC.
 *
 * POR QUE EXISTE: `new Date().toISOString().split('T')[0]` devuelve el dia en UTC.
 * En Puebla (UTC-6) eso significa que de las 18:00 en adelante los formularios
 * proponian la fecha de MAÑANA. Se detecto en el recorrido del 14-sep-2026: a las
 * 22:5x, la Nueva Recepcion traia 14/09 y el Check List traia 13/09 — el mismo
 * minuto, dos dias distintos. Y esas fechas son las que alimentan los tiempos.
 */

/** El dia de hoy como 'YYYY-MM-DD', en la zona horaria del navegador. */
export function hoyLocal() {
  const d = new Date();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mes}-${dia}`;
}

/** Una fecha cualquiera como 'YYYY-MM-DD' local. Vacio si no es una fecha. */
export function comoFechaLocal(valor) {
  if (!valor) return '';
  const d = valor instanceof Date ? valor : new Date(valor);
  if (isNaN(d.getTime())) return '';
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mes}-${dia}`;
}
